import { useEffect, useState } from "react";
import { showData } from "../../Utils/APIs/commonShowAPI";

const CommonDropdownWithId = ({ Api_path, value, onChange, label }) => {

  const [ListData, setListData] = useState([]);
  useEffect(() =>{
    showData(Api_path, setListData);
  },[])
  return (
    <div>
      <select
        className="bg-gray-50 border border-gray-700 text-gray-900 text-sm rounded-sm block w-full p-2.5"
        id="state-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">-- Select {label} --</option>
        {ListData.map(({_id, stage}) =>(
          <option key={_id} value={_id}>
            {stage}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CommonDropdownWithId;
